module.exports = __webpack_public_path__ + "static/media/swscrc4-1.9e8fef36.mp3";